import Config from '../../../server/lib/config.js'
import axios from '../util/http/index'
import Vue from 'vue'

Vue.prototype.$initFbSDK = () => {
  if (process.server) return;
  (function (d, s, id) {
    var js, fjs = d.getElementsByTagName(s)[0]
    if (d.getElementById(id)) return
    js = d.createElement(s); js.id = id
    js.src = 'https://connect.facebook.net/' + Config.LANGUAGE + '/sdk.js#xfbml=1&version=v2.12'
    fjs.parentNode.insertBefore(js, fjs)
  }(document, 'script', Config.FBID))
}

Vue.prototype.$axios = axios



// WEBPACK FOOTER //
// ./client/smsgz/plugins/rootMethods.js